import React from 'react';
import { Skeleton, Typography } from 'fronton-react';

interface IRank {
  loading: boolean;
  rankLabel: string | null;
}

export const QA_LOYALTY_RANK = 'loyalty-rank';
export const QA_LOYALTY_RANK_SKELETON = 'loyalty-rank-skeleton';

export const Rank: React.FC<IRank> = ({ loading, rankLabel }) => {
  if (loading) {
    return (
      <Typography variant="minor" size="caption" data-qa={QA_LOYALTY_RANK_SKELETON}>
        <Skeleton width="50px" height="10px" variant="control" roundingSize="xl" />
      </Typography>
    );
  }

  if (rankLabel) {
    return (
      <Typography variant="minor" size="caption" data-qa={QA_LOYALTY_RANK}>
        {rankLabel}
      </Typography>
    );
  }

  return <></>;
};
